import { OrganizationType } from '../../models';
import { User } from '../../models/user';
import { NavItem } from './navItem';

export class PartnerNavItem extends NavItem {
  override isVisible(user?: User): boolean {
    return super.isVisible(user) && user?.organization.type === OrganizationType.PARTNER;
  }
}
